export default "https://ssr-releases-cdn.paperlesspost.com/_next/static/video/UYOMobilePoster-e89d17079048cd551a4b6f740320beef.jpg";